import { observer } from 'mobx-react-lite'
import { Tab, TabList } from '@/components/Tabs'
import { Select } from '@/components/inputs/Select'
import type { FilingYear } from '@/features/jobs/details/tax-type/tax-prep-organizer/models'

interface YearTabsProps {
  years: FilingYear[]
  selectedYear: FilingYear | null
  onYearChange: (year: FilingYear) => void
  compact?: boolean
  testId?: string
}

export const YearTabs = observer(function YearTabs({
  years,
  selectedYear,
  onYearChange,
  compact = false,
  testId,
}: YearTabsProps) {
  if (compact) {
    return (
      <Select
        items={years}
        getKey={(year) => year.id ?? ''}
        getLabel={(year) => String(year.year)}
        value={selectedYear?.id ?? null}
        onChange={(key) => {
          const year = years.find((y) => y.id === key)
          if (year) {
            onYearChange(year)
          }
        }}
        testId={testId}
      />
    )
  }

  return (
    <TabList data-test={testId}>
      {years.map((year) => (
        <Tab
          key={year.id ?? year.year}
          label={String(year.year)}
          active={selectedYear?.id === year.id}
          onPress={() => onYearChange(year)}
          testId={testId ? `${testId}-${year.year}` : undefined}
        />
      ))}
    </TabList>
  )
})
